$(document).ready(function() {
  console.log("PZ")
    function moveElementOnMobile() {
        if ($(window).width() < 768) {
            // Move the element if it hasn't been moved already
            if ($('#pz-page > div:nth-child(6)').prev().get(0) !== $('#pz-page > product-block:nth-child(4)').get(0)) {
                $('#pz-page > div:nth-child(6)').insertBefore('#pz-page > product-block:nth-child(4)');
            }
          $('#pz-page > div:nth-child(3)').insertBefore('#pz-page > product-block:nth-child(1)');
          $('#pz-page > div:nth-child(9)').insertBefore('#pz-page > product-block:nth-child(7)');
        } else {
            // Optionally restore original position on larger screens
            // You'll need to adjust this based on where the element should return to
            // This is a placeholder - modify as needed for your specific case
        }
    }
    
    // Run on page load
    moveElementOnMobile();
    
    // Run on window resize
    $(window).resize(function() {
        moveElementOnMobile();
    });
});

